import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import {
  DashboardQueryProps,
  PrescriptionActivity,
} from "@customTypes/dashboard";
import { Pagination } from "@customTypes/index";

import { dashboardQKeys } from "./queryKeys";


const select = (res: any) => {
  //   console.log(res.data);
  const pagination: Pagination = {
    page: res.data.pagination.page,
    pageCount: res.data.pagination.page_count,
    pageSize: res.data.pagination.page_size,
    total: res.data.pagination.total,
  };
  const newData = [] as PrescriptionActivity[];

  if (res.data.data.length) {
    for (const i in res.data.data) {
      const {
        _id,
        patient_id,
        c_id,
        consultation_date,
        consultation_id,
        prescribed_by,
        aid,
        prescription_date,
        medications,
      } = res.data.data[i];
      newData.push({
        id: _id,
        patientId: patient_id,
        cId: c_id,
        physician: prescribed_by,
        supportStaff: aid,
        date: new Date(prescription_date),
        consultationDate: new Date(consultation_date),
        consultationId: consultation_id,
        medications: medications ?? [],
      });
    }

    return { newData, pagination };
  }

  return null;
};

export const useGetPrescriptionActivity = ({
  dateRange,
  startDate,
  endDate,
  userId,
  pagination,
}: DashboardQueryProps) => {
  const handleErrors = useQueryErrorHandling();

  return useQuery({
    queryKey: dashboardQKeys.prescriptionActivityWithFilters({
      dateRange,
      startDate,
      endDate,
      userId,
      pagination,
    }),
    queryFn: () => {
      return api.get("analytics/prescriptions/activity", {
        params: {
          range: dateRange?.replaceAll("-", "_"),
          ...(dateRange === "custom" && {
            start_date: startDate,
            end_date: endDate,
          }),
          ...(userId && {
            prescribed_by: userId,
          }),
          page: pagination?.page,
          page_size: pagination?.pageSize,
        },
      });
    },
    select,
    staleTime: 1000 * 60 * 5, // 5 minutes
    enabled:
      dateRange !== "custom" ||
      !!(dateRange === "custom" && startDate && endDate),

    onError: (res: any) => {
      console.error("[From Get Prescription activity]", res);
      handleErrors(res, "query");
    },
  });
};
